import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

const titles = [
  'Estudio de Movilidad Sustentable Comuna de La Unión', 
  'Estudio de Movilidad Sustentable Comuna de Santa Juana', 
  'Estudio de Movilidad Sustentable Comuna de San Carlos'
]
const infoData = [
  {
    headers: ['Elemento de Estandarización', 'ID', 'Nombre Indicador', 'Cálculo', 'Comentario'],
    dataKeys: ['Elemento de Estandarización', 'ID', 'Nombre Indicador', 'Calculo', 'Comentario'],
    data: [
      [
        {
          "Elemento de Estandarización": "En relación con el total de Km de la red",
          "ID": "1",
          "Nombre Indicador": "Km de calzada de prioridad ciclista en relación al total de la red",
          "Calculo": "0.04"
        },
        {
          "ID": "2",
          "Nombre Indicador": "Km de vías con prioridad de Transporte público en relación al total de la red",
          "Calculo": "0",
          "Comentario": "No existen vías de prioridad de transporte \r\npúblico en el área de estudio"
        },
        {
          "ID": "3",
          "Nombre Indicador": "Km de vías con prioridad peatón. ",
          "Calculo": "0.66"
        }
      ],
      [
        {
          "Elemento de Estandarización": "Por cantidad de habitantes",
          "ID": "4",
          "Nombre Indicador": "Km de vías cada 100.000 habitantes.",
          "Calculo": "59.64"
        },
        {
          "ID": "5",
          "Nombre Indicador": "Km de vías con prioridad de T.P público cada 100.000 habitantes.",
          "Calculo": "0",
          "Comentario": "No existen vías de prioridad de transporte \r\npúblico en el área de estudio"
        },
        {
          "ID": "6",
          "Nombre Indicador": "Km de vías de prioridad ciclista cada 100.000 habitantes.",
          "Calculo": "2.21"
        },
        {
          "ID": "7",
          "Nombre Indicador": "km de pavimentos y vías peatonales cada 100.000 habitantes.",
          "Calculo": "39.35"
        },
        {
          "ID": "8",
          "Nombre Indicador": "Identificación de Rampas (rebajes de vereda) por intersección.",
          "Calculo": "0.00%"
        },
        {
          "ID": "9",
          "Nombre Indicador": "Porcentaje de intersecciones con semáforos.",
          "Calculo": "1.12%"
        },
        {
          "ID": "10",
          "Nombre Indicador": "Porcentaje de intersecciones con cruces peatonales.",
          "Calculo": "25.15%"
        },
        {
          "ID": "11",
          "Nombre Indicador": "Porcentaje de espacio público destinado a calzadas, \r\naceras y áreas verdes.",
          "Calculo": "52.37%"
        },
        {
          "Calculo": "29.67%"
        },
        {
          "Calculo": "10.43%"
        },
        {
          "ID": "12",
          "Nombre Indicador": "Porcentaje de espacio público destinado a uso peatonal.",
          "Calculo": "29.67%"
        },
        {
          "ID": "13",
          "Nombre Indicador": "Porcentaje de espacio público destinado a uso de ciclos.",
          "Calculo": "1.08%"
        },
        {
          "ID": "14",
          "Nombre Indicador": "Porcentaje de espacio público destinado a uso de vehículos motorizados.",
          "Calculo": "52.37%"
        },
        {
          "ID": "15",
          "Nombre Indicador": "Porcentaje de espacio público destinado a uso de transporte público.",
          "Calculo": "0.00%",
          "Comentario": "No existen vías de prioridad de transporte \r\npúblico en el área de estudio"
        }
      ],
      [
        {
          "Elemento de Estandarización": "Respecto de las dinámicas ambientales y de salud",
          "ID": "16",
          "Nombre Indicador": "Árboles por hectárea.",
          "Calculo": "1.66"
        },
        {
          "ID": "17",
          "Nombre Indicador": "Árboles por habitantes. ",
          "Calculo": "0.07"
        },
        {
          "ID": "18",
          "Nombre Indicador": "Umbral mínimo de 10 árboles cada 100 metros.",
          "Calculo": "1.23",
          "Comentario": "No cumple con umbral minimo"
        },
        {
          "ID": "19",
          "Nombre Indicador": "Clasificación de pendientes del área de estudio (%).",
          "Calculo": "0 > 5 %",
          "Comentario": "A-B-C Pendiente baja"
        },
        {
          "Calculo": "5 > 30%",
          "Comentario": "D-E-F Pendiente media"
        },
        {
          "Calculo": "   <  30%",
          "Comentario": "G-H-I Pendiente alta"
        },
        {
          "ID": "20",
          "Nombre Indicador": "Porcentaje del área de estudio con pendiente\r\n baja, alta, media",
          "Calculo": "63.7%",
          "Comentario": "Baja"
        },
        {
          "Calculo": "34.8%",
          "Comentario": "Media"
        },
        {
          "Calculo": "2.4%",
          "Comentario": "Alta"
        },
      ],
      [
        {
          "Elemento de Estandarización": "Indicadores Extra",
          "ID": "21",
          "Nombre Indicador": "Porcentaje de espacio publico destinado a areas verdes",
          "Calculo": "10.4%"
        },
        {
          "ID": "22",
          "Nombre Indicador": "Cantidad de postación por km de vía",
          "Calculo": "27.92"
        },
        {
          "ID": "23",
          "Nombre Indicador": "Porcentaje de espacio de sitios eriazos",
          "Calculo": "1.76%"
        },
        {
          "ID": "24",
          "Nombre Indicador": "Porcentaje de áreas construidas.",
          "Calculo": "13.73%"
        },
        {
          "ID": "25",
          "Nombre Indicador": "Porcentaje de espacio público destinado a faja ferroviaria",
          "Calculo": "4.64%"
        },
        {
          "ID": "26",
          "Nombre Indicador": "Porcentaje de espacio público utilizado para estacionamiento",
          "Calculo": "0.84%"
        },
        {
          "ID": "27",
          "Nombre Indicador": "Superficie de estacionamiento cada 10.000 habitantes",
          "Calculo": "0.40"
        },
        {
          "ID": "28",
          "Nombre Indicador": "Número de paraderos cada 10.000 habitantes",
          "Calculo": "0.00",
          "Comentario": "Sin refugio"
        },
        {
          "Calculo": "19.62",
          "Comentario": "Con refugio"
        }
      ]
    ]
  },
  {
    headers: ['Id', 'Indicador Espacial', 'Valor'],
    dataKeys: ['Id', 'Indicador espacial', 'Valor'],
    data: [
      [
        {
          "Id": "1",
          "Indicador espacial": "Km de calzada de prioridad ciclista en relación al total de la red.",
          "Valor": "0,037 km"
        },
        {
          "Id": "2",
          "Indicador espacial": "Km de vías con prioridad de T.P público en relación al total de la red.",
          "Valor": "0"
        },
        {
          "Id": "3",
          "Indicador espacial": "Km de vías con prioridad peatón.",
          "Valor": "0,89 km"
        },
        {
          "Id": "4",
          "Indicador espacial": "Km de vías cada 10.000 habitantes.",
          "Valor": "46, km"
        },
        {
          "Id": "5",
          "Indicador espacial": "Km de vías con prioridad de transporte público cada 10.000 habitantes.",
          "Valor": "0"
        },
        {
          "Id": "6",
          "Indicador espacial": "Km de vías de prioridad ciclista cada 10.000 habitantes.",
          "Valor": "1,69 km"
        },
        {
          "Id": "7",
          "Indicador espacial": "km de pavimentos y vías peatonales cada 10.000 habitantes.",
          "Valor": "42,78 km"
        },
        {
          "Id": "8",
          "Indicador espacial": "Identificación de Rampas (rebajes de vereda) por intersección.",
          "Valor": "1.15"
        },
        {
          "Id": "9",
          "Indicador espacial": "Porcentaje de intersecciones con semáforos.",
          "Valor": "0"
        },
        {
          "Id": "10",
          "Indicador espacial": "Porcentaje de intersecciones con cruces peatonales.",
          "Valor": "46.61%"
        },
        {
          "Id": "11",
          "Indicador espacial": "Porcentaje de espacio público destinado a calzadas, aceras y áreas verdes.",
          "Valor": "59%-31%-9%"
        },
        {
          "Id": "12",
          "Indicador espacial": "Porcentaje de espacio público destinado a uso peatonal.",
          "Valor": "31%"
        },
        {
          "Id": "13",
          "Indicador espacial": "Porcentaje de espacio público destinado a uso de ciclos.",
          "Valor": "0.66%"
        },
        {
          "Id": "14",
          "Indicador espacial": "Porcentaje de espacio público destinado a uso de vehículos motorizados.",
          "Valor": "59%"
        },
        {
          "Id": "15",
          "Indicador espacial": "Porcentaje de espacio público destinado a uso de transporte público.",
          "Valor": "0"
        },
        {
          "Id": "16",
          "Indicador espacial": "Árboles por hectárea.",
          "Valor": "50.7"
        },
        {
          "Id": "17",
          "Indicador espacial": "Árboles por habitantes.",
          "Valor": "0.27"
        },
        {
          "Id": "18",
          "Indicador espacial": "Umbral mínimo de 10 árboles cada 100 metros.",
          "Valor": "60%"
        },
        {
          "Id": "19",
          "Indicador espacial": "Clasificación de pendientes del área de estudio (%).",
          "Valor": {
            type: 'subtable',
            headers: ['Pendiente', 'Categoría'],
            dataKeys: ['Pendiente', 'Categoría'],
            data: [
              {
                "Pendiente": "0 - 15 %",
                "Categoría": "Baja"
              },
              {
                "Pendiente": "16 - 39%",
                "Categoría": "Media"
              },
              {
                "Pendiente": "40 - 100%",
                "Categoría": "Alta"
              },
            ]
          }
        },
        {
          "Id": "20",
          "Indicador espacial": "Porcentaje del área de estudio con pendiente baja, alta, media (definir umbrales).",
          "Valor": {
            type: 'subtable',
            headers: ['Pendiente', 'Categoría', 'Porcentaje'],
            dataKeys: ['Pendiente', 'Categoría', 'Porcentaje'],
            data: [
              {
                "Pendiente": "0 - 15 %",
                "Categoría": "Baja",
                "Porcentaje": "94.07%"
              },
              {
                "Pendiente": "16 - 39%",
                "Categoría": "Media",
                "Porcentaje": "5.54%"
              },
              {
                "Pendiente": "40 - 100%",
                "Categoría": "Alta",
                "Porcentaje": "0.39%"
              }
            ]
          }
        },
        {
          "Id": "21",
          "Indicador espacial": "Porcentaje de espacio público destinado a áreas verdes.",
          "Valor": "8.40%"
        },
        {
          "Id": "22",
          "Indicador espacial": "Cantidad de postación por km de vía",
          "Valor": "17.48%"
        },
        {
          "Id": "23",
          "Indicador espacial": "Porcentaje de espacio de sitios eriazos",
          "Valor": "2.28%"
        },
        {
          "Id": "24",
          "Indicador espacial": "Porcentaje de áreas construidas.",
          "Valor": "10.08%"
        },
        {
          "Id": "25",
          "Indicador espacial": "Porcentaje de espacio público destinado a faja ferroviaria",
          "Valor": "0%"
        },
        {
          "Id": "26",
          "Indicador espacial": "Porcentaje de espacio público utilizado para estacionamiento",
          "Valor": "1%"
        },
        {
          "Id": "27",
          "Indicador espacial": "Superficie de estacionamiento cada 10.000 habitantes",
          "Valor": "0.55"
        },
        {
          "Id": "28",
          "Indicador espacial": "Número de paraderos cada 10.000 habitantes",
          "Valor": "26.5"
        },
        {
          "Id": "29",
          "Indicador espacial": "Número de refugio de paraderos cada 10.000 habitantes",
          "Valor": "20.1"
        },
      ]
    ]
  },
    {
    headers: [],
    dataKeys: [],
    data: []
  },
]

const extraLaunionTable1 = {
  headers: ['Pendiente', 'Categoría'],
  dataKeys: ['Pendiente', 'Categoría'],
  data: [
    {
      "Pendiente": "0 > 5 %",
      "Categoría": "A-B-C Pendiente baja"
    },
    {
      "Pendiente": "5 > 30%",
      "Categoría": "D-E-F Pendiente media"
    },
    {
      "Pendiente": "< 30%",
      "Categoría": "G-H-I Pendiente alta"
    }
  ]
}

const extraLaunionTable2 = {
  headers: ['Símbolo', 'Clases', 'Descripción'],
  dataKeys: ['Símbolo', 'Clases', 'Descripción'],
  data: [
    {
      "Clases": "Pendientes Simples (%)"
    },
    {
      "Símbolo": "A",
      "Clases": "Plano",
      "Descripción": "<1"
    },
    {
      "Símbolo": "B",
      "Clases": "Ligeramente Inclinado",
      "Descripción": "1 a <3"
    },
    {
      "Símbolo": "C",
      "Clases": "Suavemente Inclinado",
      "Descripción": "3 a <5"
    },
    {
      "Símbolo": "D",
      "Clases": "Moderadamente Inclinado",
      "Descripción": "5 a <8"
    },
    {
      "Símbolo": "E",
      "Clases": "Fuertemente Inclinado",
      "Descripción": "8 a <15"
    },
    {
      "Símbolo": "F",
      "Clases": "Ligeramente Escarpado",
      "Descripción": "15 a <30"
    },
    {
      "Símbolo": "G",
      "Clases": "Moderadamente Escarpado",
      "Descripción": "30 a <45"
    },
    {
      "Símbolo": "H",
      "Clases": "Escarpado",
      "Descripción": "45 a <60"
    },
    {
      "Símbolo": "I",
      "Clases": "Muy Escarpado",
      "Descripción": "> 60"
    }
  ]
}

const MapIndicators = ({ isOpen, projectCode, dataPosToUse, closeModal }) => {
  return (
    <Modal show={isOpen} onHide={() => closeModal()} size='xl' scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{ 'Indicadores Proyecto - ' + ((dataPosToUse > -1) ? titles[dataPosToUse] : projectCode )}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column flex-md-row">
        {projectCode && (dataPosToUse > -1) ?
          <>
            <div className="flex-1">
              <Table striped bordered hover className="border-4">
                <thead>
                  <tr>
                    {infoData[dataPosToUse].headers.map((item, itemIdx) => <th key={itemIdx}>{item}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {infoData[dataPosToUse].data.map((item, itemIdx) => (
                    item.map((itemRow, itemRowIdx) => (
                      <tr key={itemRowIdx}>
                        {infoData[dataPosToUse].dataKeys.map((cellKey, cellKeyIdx) => {
                          if (cellKey === 'Valor') {
                            if (itemRow[cellKey]?.type === 'subtable') {
                              return (
                                <td key={cellKeyIdx} className="p-0">
                                  <Table striped bordered hover className="m-0">
                                    <thead>
                                      <tr>
                                        {itemRow[cellKey].headers.map((subItemHeader, subItemHeaderIdx) => <th key={subItemHeaderIdx}>{subItemHeader}</th>)}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {itemRow[cellKey].data.map((subItem, subItemIdx) => {
                                        return (
                                          <tr key={subItemIdx}>
                                            {itemRow[cellKey].dataKeys.map((subCellKey, subCellKeyIdx) => (
                                              <td key={subCellKeyIdx}>{subItem[subCellKey]}</td>))}
                                          </tr> 
                                        )
                                      })}
                                    </tbody>
                                  </Table>
                                </td>
                              )
                            } else {
                              return (<td key={cellKeyIdx}>{itemRow[cellKey]}</td>)
                            }
                          } else {
                            return (<td key={cellKeyIdx}>{itemRow[cellKey]}</td>)
                          }
                        })}
                      </tr> 
                    ))
                  ))}
                </tbody>
              </Table>
            </div>
            {dataPosToUse === 0 ? 
              <div className="ms-md-3 sticky-md-top">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      {extraLaunionTable1.headers.map((item, itemIdx) => <th key={itemIdx}>{item}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {extraLaunionTable1.data.map((item, itemIdx) => {
                      return (
                        <tr key={itemIdx}>
                          {extraLaunionTable1.dataKeys.map((cellKey, cellKeyIdx) => {
                            return (<td key={cellKeyIdx}>{item[cellKey]}</td>)
                          })}
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
                <Table className="mt-2" striped bordered hover>
                  <thead>
                    <tr>
                      {extraLaunionTable2.headers.map((item, itemIdx) => <th key={itemIdx}>{item}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {extraLaunionTable2.data.map((item, itemIdx) => {
                      return (
                        <tr key={itemIdx}>
                          {extraLaunionTable2.dataKeys.map((cellKey, cellKeyIdx) => {
                            return (<td key={cellKeyIdx}>{item[cellKey]}</td>)
                          })}
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            : null }
          </>
        : null }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => closeModal()}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default MapIndicators
